module.exports = __webpack_public_path__ + "img/Apoptosis-INCA_10X_IC.d5d4d703.png";